import { render } from "./PvPassword.vue?vue&type=template&id=68707fd5&scoped=true"
import script from "./PvPassword.vue?vue&type=script&lang=js"
export * from "./PvPassword.vue?vue&type=script&lang=js"

import "./PvPassword.vue?vue&type=style&index=0&id=68707fd5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68707fd5"]])

export default __exports__